/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rating_NoneInputs */

const en_rating_none = /** @type {(inputs: Rating_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not rated`)
};

const de_rating_none = /** @type {(inputs: Rating_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht bewertet`)
};

/**
* | output |
* | --- |
* | "Not rated" |
*
* @param {Rating_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rating_none = /** @type {((inputs?: Rating_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rating_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rating_none(inputs)
	return en_rating_none(inputs)
});